import { connect } from 'react-redux';

import { UserOnboardingPropTypes } from './UserOnboardingPropTypes';
import UserOnboardingRootView from './UserOnboardingRootView';

const UserOnboardingRoot = (props: UserOnboardingPropTypes) => (
  <UserOnboardingRootView {...props} />
);

export default connect()(UserOnboardingRoot);
